import classNames from 'classnames';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ProHeaderAttrField } from '../../../../atoms/AttrField/AttrField';
import { ProNumberField } from '../../../../atoms/AttrField/NumberField';
import { ProButton } from '../../../../atoms/Button/ProButton';
import { ThresholdCriteriaList } from '../../../../atoms/CriteriaList/CriteriaList';
import { ProCol } from '../../../../atoms/Grid/Col';
import { ProRow } from '../../../../atoms/Grid/Row';
import { ProIconTypeData } from '../../../../atoms/Icons/IconData';
import { WindowButtonsForMode } from '../../../../atoms/WindowButtonsForMode/WindowButtonsForMode';
import { ProDetailWindow } from '../../../../components/DetailWindow/DetailWindow';
import { ProTab } from '../../../../components/DetailWindow/DetailWindowTab';
import { ApplicationElementType, getBaseBCItemForType } from '../../../../components/DetailWindow/breadCrump.helpers';
import { SelectionContext, SelectionType } from '../../../../contexts/SelectionContext';
import { UserContext } from '../../../../contexts/UserContext';
import { DetailWindowProps } from '../../../../modules/Windows/GenericDetailWindow';
import { getWindowDisplayStateMode } from '../../../../modules/Windows/WBSElement/WBSElement.helpers';
import { ProIntent, ProSize } from '../../../../utils/enums';
import { Components } from '../../../../utils/types';
import { getReqCellIcon, isReqNotBacklog, isReqOrSimilar } from '../components/RequirementTableNameCell';
import { ReqDetailWindowAnalyseTab } from './ReqDetailWindowAnalyseTab';
import { ReqDetailWindowBaseTab } from './ReqDetailWindowBaseTab';
import { ReqDetailsWindowDetailsTab } from './ReqDetailsWindowDetailsTab';
import { RequirementDetailWindowType } from './RequirementDetailsFrame';

// export const duplicateRequirement = async (element: Components.Schemas.RequirementDTO) => {
//     const jwtObj = localStorage.getItem('auth');

//     try {
//         const res = await axios.post<Components.Schemas.RequirementDTO>(
//             `${API_BASE_URL}${WBS_ELEMENT_BASE_URL}/${element.id}`,
//             { copyHierachry: true },
//             {
//                 headers: { Authorization: `Bearer ${jwtObj}` },
//             }
//         );
//         return res;
//     } catch (e) {
//         throw e;
//     }
// };

export const RequirementDetailWindow = ({
    createAction,
    deleteAction,
    formData,
    isDisabled,
    isDisplayed,
    loading,
    mode,
    saveAction,
    setFormData,
    setMode,
    error,
    cancelChanges,
    closeAction,
    t,
    internalSync,
    externalSync,
    type,
}: DetailWindowProps<Components.Schemas.RequirementDTO> & { type?: RequirementDetailWindowType }) => {
    const { portfolio } = useContext(UserContext);
    const readyCiteria = formData?.taskLists?.find((cur) => cur.tasklistType === 'ReadyCiteria');
    const acceptanceCiteria = formData?.taskLists?.find((cur) => cur.tasklistType === 'AcceptanceCiteria');

    const RequirementTypes = ['Epic', 'UserStory', 'Bug'];

    const canHasRequirements = ['UserStory', 'ChangeRequest', 'CustomerDefined'];
    const hasRequirements = canHasRequirements.includes(formData?.requirementType ?? '');
    const { push: navigate } = useHistory();

    const { selectionMode, setSelectionMode, setRenderSelectionButton, setSelectedElementId, turnSelectionOff } =
        useContext(SelectionContext);

    const selectionAction = () => {
        setSelectedElementId(formData?.id);
        setSelectionMode(SelectionType.WBSElement);

        setRenderSelectionButton(() => (elm: Components.Schemas.RequirementDTO) => (
            <div className="ProTable--actionCell">
                <ProButton
                    onClick={turnSelectionOff}
                    text={t('buttons.cancel')}
                    mainIntent={ProIntent.Transparent}
                    hoverIntent={ProIntent.Error}
                    lineIntent={ProIntent.Error}
                    size={ProSize.XSmall}
                    placement="bottom"
                />
                <ProButton
                    text={t('buttons.select')}
                    mainIntent={ProIntent.Success}
                    onClick={() => {
                        setFormData((cur) => ({ ...cur, wbsElement: elm }));
                        turnSelectionOff();
                    }}
                />
            </div>
        ));
    };

    const move = () => {
        setSelectionMode(SelectionType.Move);
        setRenderSelectionButton(() => (elm: Components.Schemas.RequirementDTO) => (
            <div className="ProTable--actionCell">
                <ProButton
                    onClick={turnSelectionOff}
                    text={t('buttons.cancel')}
                    mainIntent={ProIntent.Transparent}
                    hoverIntent={ProIntent.Error}
                    lineIntent={ProIntent.Error}
                    size={ProSize.XSmall}
                    placement="bottom"
                />
                <ProButton
                    text={t('buttons.select')}
                    mainIntent={ProIntent.Success}
                    onClick={() => {
                        saveAction({ ...formData, parentId: elm.id });
                        externalSync && externalSync();
                        turnSelectionOff();
                    }}
                />
            </div>
        ));
    };

    const duplicate = () => {
        externalSync && externalSync();
    };

    const notReady = readyCiteria?.tasks?.filter((cur) => cur.degreeOfCompletion !== 1).length !== 0;
    const notDone = acceptanceCiteria?.tasks?.filter((cur) => cur.degreeOfCompletion !== 1).length !== 0;

    useEffect(() => {
        console.log('i was rerendered');
    }, []);

    if (!formData) return <></>;

    return (
        <ProDetailWindow
            title={
                isDisabled ? (
                    <h2
                        className={classNames(
                            formData?.name?.length &&
                                formData?.name?.length >= 180 &&
                                'ProDetailWindow--header--title__large'
                        )}
                    >
                        {formData?.name ?? t('windows.details')}
                    </h2>
                ) : (
                    <ProHeaderAttrField
                        name={t('windows.name')}
                        value={formData?.name ?? String(t('windows.details'))}
                        disabled={false}
                        handleChange={(input) =>
                            setFormData((old) => ({ ...old, name: String(input).substring(0, 180) }))
                        }
                    />
                )
            }
            displayState={isDisplayed}
            icon={getReqCellIcon(formData)}
            buttonSection={
                <>
                    <WindowButtonsForMode
                        cancelAction={cancelChanges}
                        closeAction={closeAction}
                        createAction={createAction}
                        deleteAction={deleteAction}
                        mode={mode}
                        setMode={setMode}
                        saveAction={() => saveAction(formData)}
                        t={t}
                        move={
                            type === RequirementDetailWindowType.Default && isReqNotBacklog(formData) ? move : undefined
                        }
                        moveModeOn={selectionMode === SelectionType.Move}
                        cancelMove={() => setSelectionMode(undefined)}
                        duplicate={type === RequirementDetailWindowType.Default ? duplicate : undefined}
                        goToElement={
                            type !== RequirementDetailWindowType.Default
                                ? () => navigate(`/app/teams/requirements/${formData?.id}`)
                                : undefined
                        }
                    />
                </>
            }
            intent={getWindowDisplayStateMode(mode)}
            error={mode !== 'new' ? undefined : error}
            loading={loading}
            breadCrump={getBaseBCItemForType([ApplicationElementType.Requirements], t)}
        >
            {type === RequirementDetailWindowType.Grooming && (
                <ProTab name="Grooming">
                    <ProRow alignment="flex-start">
                        <ProCol span={6} className="ProDetailWindow--subSection">
                            <span className="ProDetailWindow--subSectionName">Please estimate your requirement:</span>
                            <ProNumberField
                                name={t('windows.forecastedScope')}
                                disabled={isDisabled || !isReqOrSimilar(formData)}
                                value={formData?.storyPoints}
                                handleChange={(val) => setFormData((cur) => ({ ...cur, storyPoints: Number(val) }))}
                                entity={'SP'}
                            />
                        </ProCol>
                    </ProRow>
                    <ProRow>
                        <ThresholdCriteriaList
                            cirteria={readyCiteria}
                            sync={internalSync}
                            name={t('windows.readyCeriteria')}
                        />
                    </ProRow>
                    <ProRow>
                        <ProCol span={6} className="ProDetailWindow--subSection">
                            <span className="ProDetailWindow--subSectionName">
                                If all criteria are done set it to ready
                            </span>
                            <ProButton
                                text="Ready"
                                leftIcon={ProIconTypeData.Ready}
                                disabled={notReady}
                                className="ReadyButton"
                                onClick={() => {
                                    const ready = portfolio?.requirementStates?.find((cur) => cur.name === 'ready');
                                    saveAction({ ...formData, requirementState: ready });
                                }}
                            />
                        </ProCol>
                    </ProRow>
                </ProTab>
            )}

            {type === RequirementDetailWindowType.Review && (
                <ProTab name="Review">
                    <ProRow>
                        <ThresholdCriteriaList
                            cirteria={acceptanceCiteria}
                            sync={internalSync}
                            name={'Done criteria'}
                        />
                    </ProRow>
                    <ProRow>
                        <ProCol span={12} className="ProDetailWindow--subSection">
                            <span className="ProDetailWindow--subSectionName">
                                If all criteria are done set the story to done
                            </span>
                            <ProButton
                                text="Done"
                                leftIcon={ProIconTypeData.Finnished}
                                disabled={notDone || formData.requirementState?.name === 'done'}
                                className="ReadyButton"
                                onClick={() => {
                                    const done = portfolio?.requirementStates?.find((cur) => cur.name === 'done');
                                    saveAction({ ...formData, requirementState: done });
                                }}
                            />
                        </ProCol>
                    </ProRow>
                </ProTab>
            )}

            <ProTab name={t('windows.tabs.base')}>
                <ReqDetailsWindowDetailsTab
                    RequirementTypes={RequirementTypes}
                    formData={formData}
                    isDisabled={isDisabled}
                    setFormData={setFormData}
                    t={t}
                    portfolio={portfolio}
                    internalSync={internalSync}
                    type={type}
                />
            </ProTab>

            {(type === RequirementDetailWindowType.Default || type === RequirementDetailWindowType.Daily) && (
                <ProTab name={t('windows.tabs.details')}>
                    <ReqDetailWindowBaseTab
                        formData={formData}
                        internalSync={internalSync}
                        isDisabled={isDisabled}
                        selectionAction={selectionAction}
                        selectionMode={selectionMode}
                        t={t}
                        portfolio={portfolio}
                    />
                </ProTab>
            )}
            <ProTab name={t('windows.tabs.analyse')}>
                <ReqDetailWindowAnalyseTab
                    formData={formData}
                    isDisabled={isDisabled}
                    setFormData={setFormData}
                    t={t}
                />
            </ProTab>

            {hasRequirements &&
                (type === RequirementDetailWindowType.Default || type === RequirementDetailWindowType.Planning) && (
                    <ProTab name={t('windows.tabs.criteria')}>
                        <>
                            <ProRow spacer>
                                <ThresholdCriteriaList
                                    cirteria={readyCiteria}
                                    sync={internalSync}
                                    name={t('windows.readyCeriteria')}
                                />
                            </ProRow>
                            <ProRow>
                                <ThresholdCriteriaList
                                    cirteria={acceptanceCiteria}
                                    name={t('windows.accaptanceCeriteria')}
                                    sync={internalSync}
                                />
                            </ProRow>
                        </>
                    </ProTab>
                )}
            {hasRequirements && type === RequirementDetailWindowType.Grooming && (
                <ProTab name={t('windows.tabs.accaptance')}>
                    <ProRow>
                        <ThresholdCriteriaList
                            cirteria={acceptanceCiteria}
                            name={t('windows.accaptanceCeriteria')}
                            sync={internalSync}
                        />
                    </ProRow>
                </ProTab>
            )}
        </ProDetailWindow>
    );
};
